import { render, staticRenderFns } from "./TripLegCost.vue?vue&type=template&id=90f3a3b2&"
import script from "./TripLegCost.vue?vue&type=script&lang=js&"
export * from "./TripLegCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports